<template>
    <div class="chat-list">
      <div v-for="chat in filteredChats" :key="chat.id" class="chat-item" @click="openChat(chat)">
        <div class="chat-header">
          <span class="chat-name">{{ chat.user.name }}</span>
          <span v-if="chat.unread" class="chat-unread">New</span>
        </div>
        <div class="chat-last-message">
          <p>{{ chat.lastMessage }}</p>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  
  // Definir os "emit" com defineEmits()
  const emit = defineEmits(['openChat']);  // Definindo o evento 'openChat'
  
  // Props passadas do componente pai (Chats.vue)
  const props = defineProps({
    status: String,  // Filtro de status (all, unread, online)
  });
  
  const chats = ref([
    { id: 1, user: { name: 'John Doe' }, lastMessage: 'Hello there!', unread: true, online: true },
    { id: 2, user: { name: 'Jane Smith' }, lastMessage: 'How are you?', unread: false, online: false },
    { id: 3, user: { name: 'Michael Johnson' }, lastMessage: 'Let’s meet up!', unread: false, online: true },
  ]);
  
  // Filtrar os chats com base no status ativo
  const filteredChats = computed(() => {
    if (props.status === 'unread') {
      return chats.value.filter(chat => chat.unread);
    }
    if (props.status === 'online') {
      return chats.value.filter(chat => chat.online);
    }
    return chats.value;
  });
  
  // Emitir o evento de abrir o chat
  const openChat = (chat) => {
    emit('openChat', chat);  // Emitindo o evento 'openChat' e passando o chat
  };
  </script>
  
  <style scoped>
  .chat-list {
    max-height: 400px;
    overflow-y: auto;
  }
  
  .chat-item {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }
  
  .chat-item:hover {
    background-color: #f1f1f1;
  }
  
  .chat-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
  }
  
  .chat-unread {
    color: #ff0000;
    font-weight: bold;
  }
  
  .chat-last-message {
    font-size: 0.9rem;
    color: #888;
  }
  </style>
  